import Login from '../pages/auth/Login.jsx'
import Dashboard from '../pages/dashboard/Dashboard.jsx';
import MultiOrderScreen from '../pages/dashboard/MultiOrderScreen.jsx'

export const initialRoutes = () => [
  // Auth Routes
  {
    path: "/",
    type: "auth",
    component: Login,
    title: "Login",
  },
  
  // Private Routes
  {
    path: "/dashboard",
    type: "private",
    component: Dashboard,
    title: "Dashboard",
  },
  {
    path: "/watchlist-trade",
    type: "private",
    component: MultiOrderScreen,
    title: "Watchlist Trade",
  },
];
